import React from 'react';
export function ProductShowcase() {
  const row1Colors = ['bg-[#1A2639]', 'bg-[#3A4F50]', 'bg-[#7D8A77]', 'bg-[#A49682]', 'bg-[#5C7484]', 'bg-[#2A4345]'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-216">
      <div className="max-w-5xl mx-auto text-center" data-id="element-217">
        <div data-id="element-218">
          <div className="flex items-center justify-center gap-2 text-brand-gold font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-219">
            <span className="text-xl" data-id="element-220">🏃</span> P.E. READY
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-brand-accent" data-id="element-221">
            P.E. READY: The Ultimate PE Teacher Bundle
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-222">
            <p className="text-xl md:text-2xl text-brand-ink font-bold" data-id="element-223">
              6 volumes organized by skill level and season blocks.
            </p>
            <p className="text-base md:text-lg text-brand-muted max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-224">
              120 high-impact lesson modules with step-by-step guides. 5
              strategic bonuses. Everything ready to use today.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-225">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-226">
            {row1Colors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-border rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-227">
                <span className="text-white/90 font-bold text-sm md:text-xl" data-id="element-228">
                  {i + 1}°
                </span>
              </div>)}
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-gold text-brand-gold px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-229">
            6 "TURNKEY" VOLUMES
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-2xl mx-auto mt-12" data-id="element-230">
          {['✅ Aligned with Global PE Teaching Standards', '✅ High-impact visual skill correction cues', '✅ Built-in student assessment tools', '✅ Scalable from beginner (9th category) to advanced (1st category)', '✅ Ready for any school environment or class size'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-border px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-231">
              <span className="font-medium text-brand-ink text-sm md:text-base" data-id="element-232">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}